import { GzDialog } from '../../../ui/gzDialog/component/GzDialog';
import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { SendDownloadLinksFormWebComponent } from '../../sendDowloadLinksForm';
import { Dependencies } from '../../types/dependencies';
import { SendDownloadLinksPanelEvent } from '../../sendDowloadLinksForm/events/SendDownloadLinksEvents';
import { PackageData, PackageLinksData } from '../../packagesGrid/types';

export class SendDownloadLinksDialog {
  static async open(
    dependencies: Dependencies,
    wrapper: HTMLElement,
    selectedItem: PackageData,
    sendDownloadLinks: PackageLinksData
  ): Promise<GzDialogWebComponent> {
    const sendDownloadLinksForm = new SendDownloadLinksFormWebComponent();
    sendDownloadLinksForm.setPackageId(selectedItem._id);
    sendDownloadLinksForm.setPackageProductType(selectedItem.settings.productType);
    sendDownloadLinksForm.setPackageLinks(sendDownloadLinks);

    const dialogConfigs: GzDialog = {
      headline: dependencies.translateFn('Send Download Links'),
      bodyContent: sendDownloadLinksForm,
      isOpen: true,
      isWindow: true,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs, wrapper);
    sendDownloadLinksForm.addEventListener(SendDownloadLinksPanelEvent.Close, () => dialog.close());
    sendDownloadLinksForm.addEventListener(SendDownloadLinksPanelEvent.Send, () => dialog.close());
    sendDownloadLinksForm.injectDependencies(dependencies);
    await sendDownloadLinksForm.start().then().catch();

    return dialog;
  }
}
